import { signal } from "@angular/core";
import { type KeyStoreModel } from "@bitwarden/web-vault/app/models/store/key.store.model";
import { type StoreModelNames } from "@bitwarden/web-vault/app/services/dali/type/dali.type";
import { StoreModelCollection } from "@bitwarden/web-vault/app/services/store/model.collection.abstraction";
import {
  type KeyView,
  fromStoreModel,
  fromView,
} from "@bitwarden/web-vault/app/models/view/key/key.view";

// TODO: should update the dateModified when updateView.
function updateView(this: KeyView, src: KeyView): boolean {
  let updated = false;
  const { username, password, apiKey } = src;

  if (username && this.username !== username) {
    this.username = username;
    updated = true;
  }

  if (password && this.password !== password) {
    this.password = password;
    updated = true;
  }

  if (apiKey && this.apiKey !== apiKey) {
    this.apiKey = apiKey;
    updated = true;
  }

  return updated;
}

export class KeyStoreCollection extends StoreModelCollection {
  protected type: StoreModelNames = "KeyStoreModel";
  protected models: Map<string, KeyStoreModel> = new Map<string, KeyStoreModel>();
  private _collection = signal<KeyView[]>(null);
  readonly collection = this._collection.asReadonly();

  triggerChanges(): void {
    const views: KeyView[] = [];
    this.models.forEach((model) => {
      views.push(this.deepFreeze(fromStoreModel(model)));
    });
    this._collection.set(views);
  }

  clear(): void {
    this.models.clear();
    this._collection.set(null);
  }

  async saveKeys(views: KeyView[]): Promise<boolean> {
    const updatedViews = views.reduce<KeyView[]>((acc, view) => {
      const model = this.findModel(view.id);
      const newView = model ? fromStoreModel(model) : fromView({ apiKey: "" });
      if (updateView.call(newView, view)) {
        acc.push(newView);
      }
      return acc;
    }, []);

    return updatedViews.length > 0 ? await this.saveToVault(updatedViews, true) : false;
  }

  private findModel(id: string): KeyStoreModel | undefined {
    return id ? this.models.get(id) : undefined;
  }
}
